import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Black Sheep",
  "description": "",
  "published": "2007-01-13T00:00:00.000Z",
  "redirect_from": ["/blog/black-sheep/swizec/323"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Found this amazing trailer to a film that seems surreal but apparently is in fact a real thing over at `}<a parentName="p" {...{
        "href": "http://www.commissionedcomic.com"
      }}>{`Commissioned`}</a>{`. As O said, there is no way in hell a description does this thing justice so just watch it.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.ifilm.com/video/2810911%20"
      }}>{`Go here`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      